import type { TeactNode } from '../../../lib/teact/teact';
import { getActions, withGlobal } from '../../../global';

import type { ApiPeer } from '../../../api/types';
import { ApiMessageEntityTypes } from '../../../api/types';

type OwnProps = {
  userId?: string;
  username?: string;
  children: TeactNode;
};

type StateProps = {
  userOrChat?: ApiPeer;
};

const MentionLink = ({
  userId,
  username,
  userOrChat,
  children,
}: OwnProps & StateProps) => {
  const { openChat } = getActions();

  const handleClick = () => {
    // v1: telegram-tt also handled @username opens (openChatByUsername) and
    // mobile right-column collapse — both trimmed. Open the chat by peer id.
    if (userOrChat) {
      openChat({ chatId: userOrChat.id });
    }
  };

  return (
    <a
      onClick={handleClick}
      className="text-entity-link"
      dir="auto"
      data-entity-type={userId ? ApiMessageEntityTypes.MentionName : ApiMessageEntityTypes.Mention}
    >
      {children}
    </a>
  );
};

export default withGlobal<OwnProps>(
  (global, { userId }): Complete<StateProps> => {
    return {
      // v1: direct access — telegram-tt's selectUser selector was trimmed.
      userOrChat: userId ? global.users.byId[userId] : undefined,
    };
  },
)(MentionLink);
